import { createClient } from '@supabase/supabase-js';
import { env } from '../env.js';

/**
 * Browser-side Supabase client. Uses the publishable key (safe for client).
 * For Auth + Storage. Database queries go through the API server (tRPC).
 */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
